import { __exports as es_regexp_exec } from './_virtual-es.regexp.exec.js';
import { __require as require_export } from './node_modules-core-js-internals-export.js';
import { __require as requireRegexpExec } from './node_modules-core-js-internals-regexp-exec.js';

var hasRequiredEs_regexp_exec;

function requireEs_regexp_exec () {
	if (hasRequiredEs_regexp_exec) return es_regexp_exec;
	hasRequiredEs_regexp_exec = 1;
	var $ = require_export();
	var exec = requireRegexpExec();

	// `RegExp.prototype.exec` method
	// https://tc39.es/ecma262/#sec-regexp.prototype.exec
	$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
	  exec: exec
	});
	return es_regexp_exec;
}

export { requireEs_regexp_exec as __require };
//# sourceMappingURL=node_modules-core-js-modules-es.regexp.exec.js.map
